import { render } from "./WorkflowFlow.vue?vue&type=template&id=dbfb38aa&scoped=true&ts=true"
import script from "./WorkflowFlow.vue?vue&type=script&lang=ts"
export * from "./WorkflowFlow.vue?vue&type=script&lang=ts"

import "./WorkflowFlow.vue?vue&type=style&index=0&id=dbfb38aa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfb38aa"]])

export default __exports__